import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useResendConfirmation(briefId: string) {
  const {
    mutate: resendConfirmation,
    isLoading: isResending,
    isSuccess: isResent,
    variables,
  } = useMutation({
    mutationFn: (briefInfluencerIds: string[]) =>
      BriefService.resendConfirmation(briefInfluencerIds).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
    },
  });

  return {
    resendConfirmation,
    isResending,
    isResent,
    variables,
  };
}
